import { createAction, props } from '@ngrx/store';
import { IAsqPortfolioItem } from '../models/asq-portfolios.model';

export const loadAsqPortfolios = createAction('[ASQ Portfolios] Load ASQ Portfolios');

export const loadAsqPortfoliosSuccess = createAction(
  '[ASQ Portfolios] Load ASQ Portfolios Success',
  props<{ response: IAsqPortfolioItem[] }>()
);

export const loadAsqPortfoliosFailure = createAction(
  '[ASQ Portfolios] Load ASQ Portfolios Failure',
  props<{ error: Error | any }>()
);
